/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React from 'react';
import request from '@api';
import { env } from '@constants';
import { useEffectOnce } from '@hooks';
// import useConnectionContext from '@/hooks/useConnectionContext';
import { StripeModel } from './components/StripeModel';

import './index.css';

const BankStripe = () => {
  const [clientSecret, setClientSecret] = React.useState('');
  const isProd = env === 'prod';
  // const { merchantId } = useConnectionContext();

  const domainInfo = {
    SEEL_SERVICE_DOMAIN: process.env.API_HOSTNAME,
    STRIPE_PUBLISHABLE_KEY: `${isProd ? 'pk_live_51Hrxn1AKg2GReXyisNsiozWfJgrbncGAhZ0UBTHpVs8i15LzWybZiSyCFyOZWVxeAaf3RWXzIkoNB7l9Q7FM8LYY00YuF9EThO' : 'pk_test_51Hrxn1AKg2GReXyi63Dk0VKYdlyNfr4tOA5WKFQR1q6KL3KEx2KO357rwxXTbxiVM7GTTs6KbnHkycuxL9Al5cJB00KIjj7lDo'}`,
  };
  const getClientSecret = async () => {
    // const storeClientSecret = sessionStorage.getItem(`clientSecret${merchantId}`);
    // console.log('storeClientSecret:', storeClientSecret);
    // if (storeClientSecret) {
    //   setClientSecret(storeClientSecret);
    //   return;
    // }
    try {
      const { code, data = {} } = await request('stripe-agreement/create-customer', {
        path: '/gateway/merchant-service/api/open-platform/',
        method: 'POST',
      });
      if (code === 0) {
        setClientSecret(data.clientSecret);
        // sessionStorage.setItem(`clientSecret${merchantId}`, data.clientSecret);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffectOnce(async () => {
    await getClientSecret();
  }, []);

  return <StripeModel domainInfo={domainInfo} clientSecret={clientSecret} />;
};

// export default BankStripe;

export default React.memo((props) => <BankStripe {...props} />);
